module.exports = __webpack_public_path__ + "media/images/3_clevas_complete_active-ca9dfd3f.png";